var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"dotted-loader"}),_c('div',{staticClass:"waiting-text"},[_vm._v("Waiting For Response(s)")])])])
}]

export { render, staticRenderFns }